import { useRouter } from 'next/router'
import { FC, useEffect } from 'react'
import useSWR from 'swr'

import { retrieveQuestionDetails } from '../../../api/feed'
import { retrieveSeoData } from '../../../api/seo'
import MetaTags from '../../../components/MetaTags'
import QuestionPage from '../../../components/qa/QuestionPage'
import { homePage } from '../../../data/pages'
import useScreenName from '../../../hooks/clevertap/useScreenName'
import { useLingui } from '../../../hooks/locale/useLingui'
import { extractSlug, toQAUrl } from '../../../utils/slug'
import { getQuery } from '../../../utils/utm'

const pageName = 'QA Page'

const QPage: FC = () => {
  const ScreenProvider = useScreenName(pageName)
  const LinguiProvider = useLingui()
  const router = useRouter()

  const slug = getQuery(router.query.slug)
  const id = slug?.split('-')?.slice(-1)[0]

  const { data, isValidating } = useSWR(router.isReady ? [id, 'retrieveQuestionDetails'] : null, retrieveQuestionDetails, {
    errorRetryCount: 1,
  })
  const { data: seoData } = useSWR(router.isReady ? [router.asPath, 'retrieveSeoData'] : null, retrieveSeoData, { errorRetryCount: 1 })

  const profiles = data?.userViews
  const questionView = data?.feedObjectViews && data?.feedObjectViews[0]

  useEffect(() => {
    if (!router.isReady) {
      return
    }
    // redirect to home page on no data
    if (!isValidating && !questionView?.id) {
      router.replace(homePage)
    }

    if (questionView && slug && id) {
      const realSlug = questionView.question.slug
      const uriSlug = extractSlug(slug)
      if (!realSlug && !uriSlug) {
        return
      }

      if (uriSlug != realSlug) {
        console.log({ uriSlug, realSlug })
        router.replace(toQAUrl(realSlug, id))
      }
    }
  }, [questionView, router, slug, id, isValidating])

  return (
    <ScreenProvider>
      <MetaTags ogTitle='Pregnancy,Parenting & Baby Care Tips | QnA' seoData={seoData} title='Pregnancy,Parenting & Baby Care Tips | QnA' />
      <LinguiProvider>
        {profiles?.length && questionView ? <QuestionPage profiles={profiles} questionView={questionView} /> : null}
      </LinguiProvider>
    </ScreenProvider>
  )
}

export default QPage
